import { FC } from "react";
import { LinearProgress } from "@mui/material";
import { isNotStartedYet } from "@/components/pages/budgets-and-alerts/components/grids/budgets/utils/helpers/isNotStartedYet";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { getStartsAtTitle } from "@/components/pages/budgets-and-alerts/components/grids/budgets/utils/helpers/getStartsAtTitle";

interface ResourceExplorerBudgetProgressProps {
  progress: number;
  noData?: boolean;
  startDate?: string;
}

export const ResourceExplorerBudgetProgress: FC<
  ResourceExplorerBudgetProgressProps
> = ({ progress, startDate, noData }) => {
  const isNotStarted = isNotStartedYet(startDate);

  if (noData) {
    return <TypographyWithTooltip sx={typographyStyles} title={"N/A"} />;
  }

  if (startDate && isNotStarted) {
    return (
      <TypographyWithTooltip
        sx={typographyStyles}
        title={getStartsAtTitle(startDate)}
      />
    );
  }

  return (
    <LinearProgress
      color="info"
      sx={{
        flexGrow: 1,
        height: 8,
        my: 0.25,
        borderRadius: 1,
        bgcolor: "grey.300",
        "& .MuiLinearProgress-bar": {
          bgcolor: progress > 100 ? "red" : "primary",
        },
      }}
      variant="determinate"
      value={Math.min(progress, 100)}
    />
  );
};

const typographyStyles = {
  fontSize: 10,
  color: "grey.600",
  lineHeight: "12px",
};
